import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FieldValidation } from '../../field-validation';
import { lifecycleStages } from './lifecycle-stage';
import { LifecycleStagePipeModule } from './lifecycle-stage-pipe.module';
import { InlineEditService } from '../../inline-edit.service';
import { ObjectType } from '../../../../tokens-and-interfaces';

@Component({
  template: `
    <!-- Profile Page -->
    <ng-container *ngIf="readOnly; else selectStage">
      <div class="crm-field-label">
        {{ label }}
      </div>
      <div class="crm-field-value">
        {{ control.value | stageName | async }}
      </div>
    </ng-container>
    <!-- Create / edit page -->
    <ng-template #selectStage>
      <glxy-form-field>
        <glxy-label>{{ label }}</glxy-label>
        <mat-select [formControl]="control" (blur)="saveField()">
          <mat-option *ngFor="let stage of lifecycleStages" [value]="stage.id" (mousedown)="$event.preventDefault()">
            {{ translateKey(stage.translationKey) }}
          </mat-option>
        </mat-select>
      </glxy-form-field>
    </ng-template>
  `,
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    GalaxyFormFieldModule,
    TranslateModule,
    LifecycleStagePipeModule,
  ],
})
export class LifecycleStageSelectorComponent {
  objectType!: ObjectType;
  control!: FormControl<string>;
  label!: string;
  fieldId!: string;
  validation!: FieldValidation;
  readOnly!: boolean;

  lifecycleStages = lifecycleStages;

  constructor(private readonly translate: TranslateService, private readonly inlineEditService: InlineEditService) {}

  translateKey(key: string): string {
    return this.translate.instant(key);
  }

  saveField(): void {
    this.inlineEditService.saveInlineEdit(this.objectType, {
      fieldId: this.fieldId,
      stringValue: this.control.value,
    });
  }
}
